import React, { useState } from 'react';
import Header from '../sections/Header';
import Footer from '../sections/Footer';
import Banner from '../sections/Banner';
import Breadcrumbs from '../sections/Breadcrumbs';

const EcosystemPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <Banner
        breadcrumbs={<Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Initiatives', href: '/initiatives' }, { label: 'Ecosystem' }]} />}
        title="Ecosystem Watch"
        subtitle="Tracking AI trends, vendor updates, and emerging opportunities to stay ahead of the curve."
        colorVariant="gradient"
        imageVariant="withImage"
        paddingVariant="default"
        showCTAs={true}
        showDefaultGraphic={true}
      />

      <main className="flex-1 w-full bg-white">
        <div className="max-w-7xl mx-auto px-4 py-12">
          <div className="space-y-8">
            <div className="text-center space-y-4">
              <h2 className="text-3xl font-bold text-gray-900">AI Ecosystem Overview</h2>
              <p className="text-lg text-gray-600 max-w-4xl mx-auto">
                We monitor key players in the AI ecosystem to understand their impact on our business and identify opportunities for collaboration and innovation.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[
                {
                  name: 'Microsoft',
                  logo: '/logos/Microsoft-64.png',
                  description: 'Leading enterprise AI with Azure AI services and Copilot integration.',
                  why: 'Microsoft is embedded in nearly every enterprise tech stack in Australia. Their AI offerings—especially Copilot and Azure AI services—are the most immediate and trusted pathway for our clients to explore AI use cases. AI Lab should be ready to guide safe, high-value adoption.',
                },
                {
                  name: 'Google',
                  logo: '/logos/Google-64.png',
                  description: 'Pioneering AI research and cloud-based AI solutions.',
                  why: "Google's AI tools are changing how people search, work, and build—especially in retail, government, and telco. Many of our clients are impacted by shifts to SEO, workplace productivity, and cloud infrastructure. AI Lab can help them navigate this ecosystem intelligently.",
                },
                {
                  name: 'Salesforce',
                  logo: '/logos/Salesforce-64.png',
                  description: 'AI-powered CRM and business process automation.',
                  why: 'Salesforce is entrenched in CX, service, and CRM platforms across Australia. Their AI agents promise automation and insights, but implementation risks remain. AI Lab should play an advisory role in driving safe, integrated, and customer-aligned use.',
                },
                {
                  name: 'IBM',
                  logo: '/logos/IBM-64.png',
                  description: 'Enterprise AI with focus on explainability and governance.',
                  why: "IBM's brand carries weight in regulated industries (finance, health, government). For clients needing AI with auditability, explainability, or risk controls, IBM offers a path. AI Lab can support with evaluation, integration, or vendor-neutral advice.",
                },
                {
                  name: 'Anthropic',
                  logo: '/logos/Anthropic_logo_64.png',
                  description: 'Safety-focused AI with Claude and constitutional AI.',
                  why: 'Anthropic offers a compelling alternative for clients focused on safety, transparency, and lightweight integration. Their investor base (Google, Amazon, Salesforce) is a signal of serious backing. AI Lab can evaluate where Claude might fit in future architectures.',
                },
              ].map((company, idx) => (
                <div key={company.name} className="border border-gray-200 rounded-lg bg-white p-6 flex flex-col gap-4 shadow-sm">
                  <div className="flex items-center gap-3">
                    <img src={company.logo} alt={`${company.name} logo`} className="w-12 h-12 object-contain" />
                    <div>
                      <h3 className="font-semibold text-lg text-gray-900">{company.name}</h3>
                      <p className="text-sm text-gray-600">{company.description}</p>
                    </div>
                  </div>
                  <div className="space-y-2">
                    <h4 className="font-medium text-gray-900">Why we track them:</h4>
                    <p className="text-sm text-gray-600">{company.why}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default EcosystemPage; 